import { render } from "./ParametrosView.vue?vue&type=template&id=1d4c9429"
import script from "./ParametrosView.vue?vue&type=script&lang=js"
export * from "./ParametrosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__